import SelectMonth from './SelectMonth';

interface OwnProps {
    onChange?: (month: number) => void;
    value?: number;
    width?: number | string;
}

export type Props = OwnProps;

export default SelectMonth;
